
import { useState, useEffect } from "react";
import axiosConfig from '../axiosConfig';
import Header from "../Header/Header";
import MainMenu from "../MainMenu/MainMenu";
import { useParams } from "react-router-dom";




const AppUserActivityLog = () => {
    const { id } = useParams();

    const [appUser, setAppUser] = useState([]);
    const [appUserActivityLog, setAppUserActivityLog] = useState([]);

    const [query, setQuery] = useState("");
    useEffect(() => {
        axiosConfig.get("/appuser/activity/log/" + id).then((rsp) => {
            setAppUser(rsp.data.userData);
            setAppUserActivityLog(rsp.data.user_activity_logs);
            //console.log(rsp.data);
        }, (err) => { });


    }, []);


    const Search = (data) => {
        return data.filter(
            (item) =>
                item.operation_type.toLowerCase().includes(query.toLowerCase()) ||
                item.data.type && item.user_id.toString().includes(query) ||
                item.data.category && item.user_id.toString().includes(query)
        );
    };



    



    return (
        <div><Header title="App User Login Sessions" />
            <MainMenu menu="appusers" />
            <div class="app-content content">
                <div class="content-overlay"></div>
                <div class="content-wrapper" style={{ backgroundColor: "azure" }} >
                    <div class="content-header row">
                    </div>
                    <div class="content-body">



                        <div class="row justify-content-md-center">
                            <div class="col-xl-12  col-12">
                                <section id="horizontal-vertical">
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="card">

                                                <div class="card-content collapse show">
                                                    <div class="card-body card-dashboard">

                                                        <div class="row">
                                                            <div class="col-md-7"><div class="h3 font-weight-bold">{appUser.user_name} - Activity Logs</div></div>
                                                            <div class="col-md-5"><input type="text" class="search form-control round border-primary mb-1" placeholder="Search" onChange={e => setQuery(e.target.value)} />
                                                            </div>

                                                        </div>
                                                        {/* <a class="btn btn-primary" href="/device/create">Create New</a> */}
                                                        {/* <button class="btn btn-success pull-right" onClick={exportDevices}>Export</button> */}
                                                        <div class="table-responsive" style={{ maxHeight: '400px', minHeight: '500px' }}>
                                                            {
                                                                appUserActivityLog.length > 0 ?
                                                                    <table class="table display nowrap table-striped table-bordered">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Operation</th>
                                                                                <th>Type</th>
                                                                                <th>Date</th>
                                                                                <th>Query Data (Raw)</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {Search(appUserActivityLog).map((log) =>
                                                                                <tr key={log.id}>
                                                                                    <td class="text-warning">{log.operation_type}</td>
                                                                                    <td>{log.operation_type == "report_generate_new" ? log.data.type : log.data.category}</td>
                                                                                    <td>{log.date_time}</td>
                                                                                    <td>
                                                                                        {log.operation_type == "report_generate_new" ? <>ResultRow: {log.data.ResultRow}<br /></> : null}
                                                                                        <textarea className="form-control" style={{ height: '100px' }} disabled value={`Query: ${log.data_json}`} />
                                                                                    </td>
                                                                                </tr>
                                                                            )}
                                                                        </tbody>
                                                                    </table>
                                                                    : <div class="h3 font-weight-bold text-center">No Log Found in this session</div>
                                                            }



                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </section >





                            </div>
                        </div>


                        <br />



                        <br />


                    </div>
                </div>

            </div>
        </div>
    )

}
export default AppUserActivityLog;